import { API_BASE_URL, HEADERS_WITH_TOKEN } from 'services/api/BaseUrl'

/* export const getAll = () =>
  fetch(
    `${API_BASE_URL}/product-tags`,
    {
      method: 'GET',
      headers: HEADERS_WITH_TOKEN(localStorage.getItem('mqadtk'))
    }
  )
    .then(res => res.json()) */

export const getAll = async () => {
  const usr = JSON.parse(localStorage.getItem('mqadusr'))

  const res = await fetch(
    `${API_BASE_URL}/product-tags?cmp=${usr.company._id}`,
    {
      method: 'GET',
      headers: HEADERS_WITH_TOKEN(localStorage.getItem('mqadtk'))
    }
  )
  return await res.json()
}


export const save = async (params) => {
  const res = await fetch(
    `${API_BASE_URL}/product-tags`,
    {
      method: 'POST',
      headers: HEADERS_WITH_TOKEN(localStorage.getItem('mqadtk')),
      body: JSON.stringify(params)
    }
  )
  return await res.json()
}

export const edit = async (data) => {
  const { id, params } = data
  const res = await fetch(
    `${API_BASE_URL}/product-tags/${id}`,
    {
      method: 'PUT',
      headers: HEADERS_WITH_TOKEN(localStorage.getItem('mqadtk')),
      body: JSON.stringify(params)
    }
  )
  return await res.json()
}

export const remove = async (id) => {
  const usr = JSON.parse(localStorage.getItem('mqadusr'))

  const res = await fetch(
    `${API_BASE_URL}/product-tags/${id}`,
    {
      method: 'DELETE',
      headers: HEADERS_WITH_TOKEN(localStorage.getItem('mqadtk')),
      body: JSON.stringify({ cmp: usr.company._id })
    }
  )
  return await res.json()
}

export const updateActive = async (data) => {
  const { id, params } = data
  const res = await fetch(
    `${API_BASE_URL}/product-tags/update-active/${id}`,
    {
      method: 'POST',
      headers: HEADERS_WITH_TOKEN(localStorage.getItem('mqadtk')),
      body: JSON.stringify(params)
    }
  )
  return await res.json()
}